var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSrStarsGreenLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.505,
    height: 29.957,
    viewBox: "0 0 31.505 29.957",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2913",
    "data-name": "Group 2913",
    transform: "translate(-415 -585.098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2898",
    "data-name": "Group 2898",
    transform: "translate(415 585.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8539",
    "data-name": "Path 8539",
    d: "M22.971,9,26.84,20.239,38.7,20.46l-9.47,7.148L32.7,38.957l-9.728-6.78-9.728,6.78L16.67,27.608,7.2,20.46l11.865-.221Z",
    transform: "translate(-7.2 -9)",
    fill: "#01754a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSrStarsGreenLarge);
export default __webpack_public_path__ + "static/media/SR_Stars_green_large.804b3f5aa6cd9cf3645c2e8a35d935af.svg";
export { ForwardRef as ReactComponent };